module.exports = __webpack_public_path__ + "img/9788936452018.7ac2f397.jpg";